export default __webpack_public_path__ + "static/media/stat4.62487236.png";